
(function () {
  var BLOCK_ID = 'wb-appstle-referral-qr';
  var STORAGE_KEY = 'wb_appstle_referral_url';
  var PRIMARY_BLUE = '#0000e1';
  var REFERRAL_HOST = 'refer.wonderbiotics.com';

  function isLoyaltyPage() {
    return window.location.pathname.replace(/\/+$/, '') === '/apps/loyalty';
  }

  function isFriendClaimRoute() {
    var params = new URLSearchParams(window.location.search);
    return params.get('appstle_referral') === 'true' || params.has('appstle_referral_code');
  }

  function forceReferralSection() {
    if (!isLoyaltyPage() || isFriendClaimRoute()) return;
    if (!window.location.hash || window.location.hash === '#appstle-loyalty') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#appstle-loyalty-referrals');
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  }

  function cleanUrl(value) {
    if (!value) return '';
    return String(value).replace(/\s+/g, '').trim();
  }

  function findReferralUrl() {
    var anchors = Array.prototype.slice.call(document.querySelectorAll('a[href*="' + REFERRAL_HOST + '"]'));
    for (var i = 0; i < anchors.length; i += 1) {
      var href = cleanUrl(anchors[i].href || anchors[i].getAttribute('href'));
      if (href.indexOf(REFERRAL_HOST) !== -1) return href;
    }

    var fields = Array.prototype.slice.call(document.querySelectorAll('input[value*="' + REFERRAL_HOST + '"], textarea'));
    for (var j = 0; j < fields.length; j += 1) {
      var value = cleanUrl(fields[j].value || fields[j].textContent);
      if (value.indexOf(REFERRAL_HOST) !== -1) return value;
    }

    var text = document.body ? document.body.innerText || '' : '';
    var match = text.match(/https?:\/\/refer\.wonderbiotics\.com\/[A-Za-z0-9_-]+/);
    if (match) return cleanUrl(match[0]);

    try {
      var stored = cleanUrl(window.localStorage.getItem(STORAGE_KEY));
      if (stored.indexOf(REFERRAL_HOST) !== -1) return stored;
    } catch (error) {}

    return '';
  }

  function rememberReferralUrl(referralUrl) {
    if (!referralUrl || referralUrl.indexOf(REFERRAL_HOST) === -1) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, referralUrl);
    } catch (error) {}
  }

  function findStablePlacement() {
    var appstlePage = document.getElementById('appstleLoyaltyPage');
    if (appstlePage && appstlePage.parentNode) return appstlePage;

    var main = document.querySelector('main, #MainContent, .main-content');
    if (main) return main;

    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    for (var i = scripts.length - 1; i >= 0; i -= 1) {
      if ((scripts[i].src || '').indexOf('wb-appstle-referral-qr.js') !== -1 && scripts[i].parentNode) {
        return scripts[i];
      }
    }
    return document.body;
  }

  function buildBlock(referralUrl) {
    var block = document.createElement('section');
    block.id = BLOCK_ID;
    block.setAttribute('aria-label', 'WonderBiotics referral QR code');
    block.style.cssText = [
      'box-sizing:border-box',
      'max-width:420px',
      'margin:22px auto 0',
      'padding:18px',
      'border:1px solid #e4e6f6',
      'border-radius:14px',
      'background:#ffffff',
      'box-shadow:0 10px 28px rgba(0,0,0,.08)',
      'text-align:center',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif'
    ].join(';');
    block.setAttribute('data-wb-referral-url', referralUrl);

    var title = document.createElement('p');
    title.textContent = 'Scan to give your friend 50% off';
    title.style.cssText = [
      'margin:0 0 8px',
      'font-size:18px',
      'line-height:1.3',
      'font-weight:800',
      'color:' + PRIMARY_BLUE
    ].join(';');

    var copy = document.createElement('p');
    copy.textContent = 'Your friend can scan this QR code to get 50% off their first WonderBiotics subscription.';
    copy.style.cssText = [
      'margin:0 0 14px',
      'font-size:14px',
      'line-height:1.45',
      'color:#555'
    ].join(';');

    var img = document.createElement('img');
    img.src = 'https://quickchart.io/qr?size=300&margin=2&text=' + encodeURIComponent(referralUrl);
    img.width = 220;
    img.height = 220;
    img.alt = 'QR code for your WonderBiotics referral link';
    img.loading = 'lazy';
    img.style.cssText = [
      'display:block',
      'width:220px',
      'height:220px',
      'max-width:100%',
      'margin:0 auto',
      'padding:10px',
      'border:1px solid #eeeeff',
      'border-radius:10px',
      'background:#fff'
    ].join(';');

    var link = document.createElement('a');
    link.href = referralUrl;
    link.textContent = 'Open my referral link';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.cssText = [
      'display:inline-block',
      'margin-top:12px',
      'font-size:13px',
      'line-height:1.4',
      'color:' + PRIMARY_BLUE,
      'text-decoration:underline',
      'font-weight:700'
    ].join(';');

    block.appendChild(title);
    block.appendChild(copy);
    block.appendChild(img);
    block.appendChild(link);
    return block;
  }

  function nearestCard(element) {
    var node = element;
    for (var i = 0; i < 9 && node && node !== document.body; i += 1) {
      var rect = node.getBoundingClientRect ? node.getBoundingClientRect() : null;
      if (rect && rect.width >= 220 && rect.width <= 780 && rect.height >= 90 && rect.height <= 820) {
        return node;
      }
      node = node.parentElement;
    }
    return element;
  }

  function hideRewardCouponUi() {
    if (!isLoyaltyPage() || isFriendClaimRoute()) return;
    var all = Array.prototype.slice.call(document.querySelectorAll('h1,h2,h3,p,div,span,section,article'));
    all.forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^You have \d+ rewards? available$/i.test(text)) {
        node.textContent = 'Share your link so a friend can claim 50% OFF.';
      }
      if (
        text.indexOf('Welcome gift! Apply this to save 50% on your probiotic subscription.') !== -1 ||
        text.indexOf('Use the below coupon to get your discount') !== -1 ||
        /\bAL_[A-Za-z0-9_-]{8,}\b/.test(text)
      ) {
        var card = nearestCard(node);
        card.style.display = 'none';
        card.setAttribute('data-wb-hidden-reward-coupon', 'true');
      }
    });
  }

  function renderQr() {
    if (!isLoyaltyPage()) return;
    var referralUrl = findReferralUrl();
    if (!referralUrl) return;
    rememberReferralUrl(referralUrl);
    var existing = document.getElementById(BLOCK_ID);
    if (existing) {
      if (existing.getAttribute('data-wb-referral-url') !== referralUrl) {
        existing.replaceWith(buildBlock(referralUrl));
      }
      return;
    }
    var placement = findStablePlacement();
    if (!placement || !placement.parentNode) return;
    if (placement === document.body) {
      document.body.appendChild(buildBlock(referralUrl));
    } else {
      placement.insertAdjacentElement('afterend', buildBlock(referralUrl));
    }
  }

  function start() {
    if (!isLoyaltyPage()) return;
    forceReferralSection();
    hideRewardCouponUi();
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      forceReferralSection();
      hideRewardCouponUi();
      renderQr();
      if (document.getElementById(BLOCK_ID) || attempts >= 40) window.clearInterval(timer);
    }, 500);

    var observer = new MutationObserver(function () {
      forceReferralSection();
      hideRewardCouponUi();
      renderQr();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
